module.exports = __webpack_public_path__ + "static/img/plan_category_three_lesson.4e72eb7d.png";